import {useFeatureFlags} from "../../providers/FeatureFlagProvider/FeatureFlagProvider";

export const useIsPackingHealthEnabled = () : boolean => {
    const featureFlags = useFeatureFlags();
    return featureFlags.includes("isPackingHealthEnabled");
}